var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-qr-code"},[(!_vm.link)?_c('div',{staticClass:"empty-text"},[_vm._v("暂无可生成的链接")]):_c('canvas',{ref:"canvasRef"})])
}
var staticRenderFns = []

export { render, staticRenderFns }